import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <Header />
            <div className="pt-32 pb-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-[#071028] mb-8">Política de Privacidade</h1>

                <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                    <p>A sua privacidade é importante para nós. É política do Marcelo Carvalho Transportes respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">1. Coleta de Informações</h2>
                    <p>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço (como um orçamento de mudança). Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">2. Uso das Informações</h2>
                    <p>As informações coletadas são utilizadas exclusivamente para entrar em contacto consigo sobre o seu pedido de orçamento e para a prestação do serviço contratado. Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">3. Retenção de Dados</h2>
                    <p>Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">4. Seus Direitos</h2>
                    <p>Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</p>

                    <h2 className="text-2xl font-semibold text-[#071028] mt-8">5. Cookies</h2>
                    <p>Utilizamos cookies apenas para melhorar a sua experiência de navegação no nosso site. Você pode optar por desativar os cookies nas configurações do seu navegador.</p>

                    <p className="mt-12 text-sm">Esta política é efetiva a partir de Janeiro de 2026.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
